export default {
    en: {
        id: 'exercise7',
        answers: [
            {
                title: `<div class="box-title">Need 500 more people</div>`,
                answer: 1,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Build a separate facility to house the new entrants</div>`,
                answer: 2,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Demand for 1 million hours a year over each of the next 5 years</div>`,
                answer: 3,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Handle the growing work load efficiently</div>`,
                answer: 4,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Can’t absorb in present facility without loss of productivity</div>`,
                answer: 5,
                hasArrow: true
            },
        ],
        image: '5b1-1.png'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5c/practiceDefiningProblem2/i18n/exercise7.js